import {
  Checkbox,
  FileUpload,
  Input,
  Select,
  useTraversal,
} from '@guillotinaweb/react-gmi'
import { Switch, Tabs, message } from 'antd'
import React, { memo, useState } from 'react'
import { I18NField } from '../../../components/i18nfield'
import { ProductSelector } from '../../../components/product-selector'
import { buttonThemes, frontThemes, getCdnUrl, setLangs } from '../../../consts'

const Empty = () => null

export const ImageForm = memo(({ selected, edit, langs, id }) => {
  const Ctx = useTraversal()
  const [uploading, setUploading] = useState(false)
  const [images, setImages] = useState(setLangs([]))

  function onUploadBanner(lang) {
    return async (file) => {
      setUploading(true)
      const filename = `home/${Ctx.state.context['@name']}`
      const res = await Ctx.client.upload(Ctx.path, file, filename)

      if (res.status >= 300) {
        message.error('Error uploading the image')
        setUploading(false)
        return
      }

      const { path } = await res.json()
      const src = `/${path}`
      const image = selected.image || {}
      const isFirstImage = !Object.values(image).find((v) => {
        return v
      })

      edit('image', isFirstImage ? setLangs(src) : { ...image, [lang]: src })
      setUploading(false)
    }
  }

  function onUploadBannerMultipleImage(lang) {
    return async (file) => {
      setUploading(true)
      const filename = `home/${Ctx.state.context['@name']}`
      const res = await Ctx.client.upload(Ctx.path, file, filename)

      if (res.status >= 300) {
        message.error('Error uploading the image')
        setUploading(false)
        return
      }

      const { path } = await res.json()
      const src = `/${path}`
      const foldersLanguage = setLangs(src)
      const allImages = { ...selected.images } || images
      if (lang === langs[0]) {
        Object.keys(allImages).map(
          (locale) =>
            (allImages[locale] = [
              ...allImages[locale],
              foldersLanguage[locale],
            ])
        )
      } else {
        allImages[lang] = [...allImages[lang], foldersLanguage[lang]]
      }
      setImages(allImages)
      edit('images', allImages)
      setUploading(false)
    }
  }

  const onChangeMultipleLinks = (value, lang, imageSrc) => {
    const allLinks = { ...(selected.buttonLink || setLangs([])) }
    const allImages = { ...selected.images }
    const imagesList = allImages[lang]
    const index = imagesList.indexOf(imageSrc)

    allLinks[lang][index] = value

    edit('buttonLink', allLinks)
  }

  return (
    <I18NField key={langs.join()} langs={langs} Widget={Empty}>
      {(lang) => (
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="General" key={`general-${lang}`}>
            {id === 'image' ? (
              <>
                <label className="label">Image</label>
                <FileUpload
                  accept="image/*"
                  onChange={onUploadBanner(lang)}
                  label={uploading ? 'Uploading...' : 'Upload an image'}
                />
              </>
            ) : (
              <>
                <label className="label">Images</label>
                <FileUpload
                  accept="image/*"
                  onChange={onUploadBannerMultipleImage(lang)}
                  label={uploading ? 'Uploading...' : 'Upload product photos'}
                />
              </>
            )}
            {id === 'image' && selected.image?.[lang] ? (
              <img
                src={`${getCdnUrl()}${selected.image?.[lang]}`}
                alt="Banner preview"
              />
            ) : (
              selected.images?.[lang].length !== 0 &&
              selected.images?.[lang].map((image, index) => {
                return (
                  <div key={image} style={{ position: 'relative' }}>
                    <button
                      onClick={() => {
                        const images = selected.images
                        images[lang].splice(index, 1)
                        edit('images', images)
                      }}
                      className="button-delete-image"
                    >
                      X
                    </button>
                    <img src={`${getCdnUrl()}${image}`} alt="Banner preview" />
                  </div>
                )
              })
            )}
            <label className="label mt10">Theme</label>
            <Select
              options={frontThemes.map((k) => ({ label: k, value: k }))}
              value={selected.theme}
              onChange={(e) => edit('theme', e.target.value)}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Text & button" key={`text-button-${lang}`}>
            {selected.id !== 'image-slider' && (
              <>
                <label className="label">Title</label>
                <Input
                  value={selected.title?.[lang] || ''}
                  onChange={(v) =>
                    edit('title', { ...selected.title, [lang]: v })
                  }
                />
                <label className="label">Text</label>
                <Input
                  value={selected.textBanner?.[lang] || ''}
                  onChange={(v) =>
                    edit('textBanner', { ...selected.textBanner, [lang]: v })
                  }
                />
                <Checkbox
                  placeholder=" Set big size title and text"
                  value={selected.textBigger}
                  onChange={(v) => edit('textBigger', v)}
                />
                <label className="label">Button text</label>
                <Input
                  value={selected.buttonText?.[lang] || ''}
                  onChange={(v) =>
                    edit('buttonText', { ...selected.buttonText, [lang]: v })
                  }
                />
                <label className="label">Button theme</label>
                <Select
                  options={buttonThemes.map((k) => ({ label: k, value: k }))}
                  value={selected.buttonTheme}
                  onChange={(e) => edit('buttonTheme', e.target.value)}
                />
              </>
            )}

            <label className="label">
              Button link (image link when button text is missing)
            </label>
            {id === 'image' ? (
              <Input
                value={selected.buttonLink ? selected.buttonLink[lang] : ''}
                onChange={(v) =>
                  edit('buttonLink', { ...selected.buttonLink, [lang]: v })
                }
              />
            ) : (
              selected.images[lang] &&
              selected.images[lang].map((imageSrc, index) => {
                return (
                  <div>
                    <label>{selected.images[lang][index]}</label>
                    <Input
                      value={
                        selected.buttonLink &&
                        selected.buttonLink[lang] &&
                        selected.buttonLink[lang][index]
                          ? selected.buttonLink[lang][index]
                          : ''
                      }
                      onChange={(v) => {
                        onChangeMultipleLinks(v, lang, imageSrc)
                      }}
                    />
                  </div>
                )
              })
            )}
          </Tabs.TabPane>
          {selected.id === 'product-image' && (
            <Tabs.TabPane tab="Products to display" key={`products-${lang}`}>
              <label className="label">Products</label>
              <ProductSelector
                id={selected.id}
                type="group"
                products={selected.query?.groups || []}
                onChange={(groups) => {
                  if (groups.length > 4) {
                    return message.error(
                      'This section can show a maximum of 4 products.'
                    )
                  }
                  edit('query', { groups })
                }}
              />
            </Tabs.TabPane>
          )}
          <Tabs.TabPane
            tab="Image properties"
            key={`image-properties-${lang}`}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent:
                selected.id === 'image' ? 'space-around' : 'flex-start',
              alignItems: 'center',
            }}
          >
            <div>
              <label className="label mt10">Filter</label>
              <Select
                options={['no filter', 'clear', 'dark'].map((k) => ({
                  label: k,
                  value: k,
                }))}
                value={selected.filter ? selected.filter : 'no filter'}
                onChange={(e) => {
                  const v = e.target.value
                  edit('filter', v === 'no filter' ? undefined : v)
                }}
              />
              {selected.id === 'image' && (
                <>
                  <label className="label">Image repeat</label>
                  <Switch
                    defaultChecked={selected.imageRepeat}
                    onChange={(v) => edit('imageRepeat', v)}
                  />
                </>
              )}

              <label className="label">Image cover</label>
              <Switch
                defaultChecked={selected.imageCover}
                onChange={(v) => edit('imageCover', v)}
              />
              {selected.id === 'image' && (
                <>
                  <label className="label">Remove padding</label>
                  <Switch
                    defaultChecked={selected.removePadding}
                    onChange={(v) => edit('removePadding', v)}
                  />
                </>
              )}
            </div>
            {selected.id === 'image' && (
              <div>
                <label className="label">Width</label>
                <Select
                  options={['regular', 'big', 'full'].map((k) => ({
                    label: k,
                    value: k,
                  }))}
                  value={selected.widthSize}
                  onChange={(e) => edit('widthSize', e.target.value)}
                />

                <label className="label">Height (in pixels)</label>
                <Input
                  min={0}
                  type="number"
                  value={selected.height}
                  onChange={(v) => edit('height', parseFloat(v))}
                />
              </div>
            )}
          </Tabs.TabPane>
        </Tabs>
      )}
    </I18NField>
  )
})
